// import { ObservableMap } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { LeftPhotoArrow, RightPhotoArrow } from '../../images/images';
// import { Routes } from '../../_controllers/RouteController';
// import { LeftPhotoArrow, RightPhotoArrow } from '../../images/images';

import { IStory } from '../../Stores/StoryStore';

import { styles } from './PhotoViewerStyles';

import { PhotoCarousel } from './PhotoCarousel';
// import { CommentType } from './PhotoViewer';
// import { styles } from './PhotoViewerStyles';
// import { styles } from './PhotoViewerStyles';
// import { RightPhotoArrow, LeftPhotoArrow } from '../../images/images';

interface IProps {
    story: IStory;
    selectedIndex: number;
    photo: any;
    tryUpdateRoutePhotoID(index: number, story: IStory): void;
    onClickLeft(): void;
    onClickRight(): void;
}

@inject('store')
@observer
export class CarouselView extends React.Component<IProps> {

    public render() {
        const { story, selectedIndex, onClickLeft, onClickRight, tryUpdateRoutePhotoID } = this.props;
        const photo = story.photosWithComments[selectedIndex].photo;

        return (
            <React.Fragment>
                <div style={styles.photoContainer}>
                    <div style={{ ...styles.image, backgroundImage: `url(${photo.url})` }}>
                        <img
                            src={LeftPhotoArrow}
                            style={styles.arrowImage}
                            onClick={onClickLeft}

                        />
                        <img
                            src={RightPhotoArrow}
                            style={styles.arrowImage}
                            onClick={onClickRight}
                        />
                    </div>
                </div>
                <div style={styles.footerContainer}>
                    <PhotoCarousel
                        story={story}
                        selectedIndex={selectedIndex}
                        onClick={tryUpdateRoutePhotoID}
                        onClickLeft={onClickLeft}
                        onClickRight={onClickRight}
                    />
                    {/*<div style={styles.bottomFooterContainer}>*/}
                    {/*    <div />*/}
                    {/*</div>*/}
                </div>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/CarouselView.tsx